export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12107.96f0aa67.jpg";